export function getFinalExamQuestions() {
    // For brevity, we’ll just define 50 placeholders with advanced Grade 12 topics.
    // You can adjust or expand the Q/A as needed.
    return [
      // Q1
      {
        question: () => ({
          q: `
            <p><strong>Q1:</strong> If <code>f(x)=x^2</code> and <code>g(x)=3x+2</code>, 
            then <code>(f∘g)(x)</code> = ?</p>
          `,
          a: "<code>(3x+2)^2</code>",
          distract: [
            "<code>3(x^2)+2</code>",
            "<code>x^2+3x+2</code>",
            "<code>(x-2)^2</code>"
          ]
        })
      },
      // Q2
      {
        question: () => ({
          q: `
            <p><strong>Q2:</strong> A 4th degree polynomial can have at most how many turning points?</p>
          `,
          a: "3",
          distract: ["4","2","No max limit"]
        })
      },
      // Q3
      {
        question: () => ({
          q: `
            <p><strong>Q3:</strong> For <code>y=(x+1)/(x-1)</code>, the domain excludes <code>x</code>=?</p>
          `,
          a: "1",
          distract: ["-1","0","No exclusions"]
        })
      },
      // Q4
      {
        question: () => ({
          q: `
            <p><strong>Q4:</strong> The inverse function of <code>y = 2^x</code> is
            <code>y = \\log_2(x)</code>. True or false?</p>
          `,
          a: "True",
          distract: ["False", "No real inverse exists", "y = \\ln(x) / 2"]
        })
      },
      // Q5
      {
        question: () => ({
          q: `
            <p><strong>Q5:</strong> The identity <code>sin^2(x) + cos^2(x)=1</code> is fundamental. True?</p>
          `,
          a: "True",
          distract: [
            "False",
            "Equivalent to sin(2x)",
            "No longer used in Grade 12"
          ]
        })
      },
      // Q6
      {
        question: () => ({
          q: `
            <p><strong>Q6:</strong> The amplitude of <code>y=5 sin(2x)</code> is?</p>
          `,
          a: "5",
          distract: ["2","10","5/2"]
        })
      },
      // Q7
      {
        question: () => ({
          q: `
            <p><strong>Q7:</strong> Which integer values satisfy
            <code>x^2 = 4^x</code>?</p>
          `,
          a: "x = 2 or x = 4",
          distract: ["x = 1", "x = 0", "No integer solution"]
        })
      },
      // Q8
      {
        question: () => ({
          q: `
            <p><strong>Q8:</strong> Number of ways to arrange 5 distinct letters in 3 spots = ?</p>
          `,
          a: "5P3=60",
          distract: ["5C3=10","15","120"]
        })
      },
      // Q9
      {
        question: () => ({
          q: `
            <p><strong>Q9:</strong> In a normal distribution, about 95% of data is within how many std devs?</p>
          `,
          a: "2",
          distract: ["1","3","No fixed range"]
        })
      },
      // Q10
      {
        question: () => ({
          q: `
            <p><strong>Q10:</strong> <code>lim(x→2) [(x^2-4)/(x-2)]</code> => ?</p>
          `,
          a: "4",
          distract: ["2","0","∞"]
        })
      },
      // Q11
      {
        question: () => ({
          q: `
            <p><strong>Q11:</strong> If
            <code>f(x)=x^2</code> and <code>g(x)=\\sqrt{x}</code>,
            which statement is <em>true</em>?</p>
          `,
          a: "<code>f(g(x)) = x</code> for x ≥ 0",
          distract: [
            "<code>g(f(x)) = x</code> for all real x",
            "<code>f∘g</code> and <code>g∘f</code> are identical",
            "Neither composition is defined"
          ]
        })
      },
      // Q12
      {
        question: () => ({
          q: `
            <p><strong>Q12:</strong> If a polynomial has roots 1, -2, 3, the factored form includes?</p>
          `,
          a: "<code>(x - 1)(x + 2)(x - 3)</code>",
          distract: [
            "<code>(x-1)(x-2)(x-3)</code>",
            "<code>(x+1)(x-2)(x+3)</code>",
            "None"
          ]
        })
      },
      // Q13
      {
        question: () => ({
          q: `
            <p><strong>Q13:</strong> For <code>y=(x^2-9)/(x-3)</code>, we have a hole at <code>x=?</code></p>
          `,
          a: "3",
          distract: [
            "-3",
            "No hole, it’s an asymptote",
            "Hole at x=0"
          ]
        })
      },
      // Q14
      {
        question: () => ({
          q: `
            <p><strong>Q14:</strong> Solve <code>3^x = 15</code>.
            Express your answer exactly.</p>
          `,
          a: "<code>x = \\log_3(15)</code>",
          distract: [
            "<code>x = \\ln(15)</code>",
            "<code>x = 5\\log(3)</code>",
            "No real solution"
          ]
        })
      },
      // Q15
      {
        question: () => ({
          q: `
            <p><strong>Q15:</strong> <code>cos(A - B) = cosA cosB + sinA sinB</code>. True?</p>
          `,
          a: "True",
          distract: [
            "False, sign is reversed",
            "No identity",
            "That’s sin(A−B)"
          ]
        })
      },
      // Q16
      {
        question: () => ({
          q: `
            <p><strong>Q16:</strong> If <code>y=A cos(Bx)</code>, the period=<code>2π/B</code>. True?</p>
          `,
          a: "True",
          distract: [
            "False, period=2πB",
            "Period=π/B",
            "No period for cos function"
          ]
        })
      },
      // Q17
      {
        question: () => ({
          q: `
            <p><strong>Q17:</strong> Solve <code>x^2=8^x</code> for x &ge; 0. Possible integer solutions?</p>
          `,
          a: "x=2, x=4 (though in some checks, 8^2=64 vs 2^2=4, etc. Usually a tricky question)",
          distract: ["x=3 only","No solution","x=1, x=8"]
        })
      },
      // Q18
      {
        question: () => ({
          q: `
            <p><strong>Q18:</strong> 8 distinct items choose 3 => # combinations=?</p>
          `,
          a: "8C3=56",
          distract: ["8P3=336","24","28"]
        })
      },
      // Q19
      {
        question: () => ({
          q: `
            <p><strong>Q19:</strong> 1 std dev from mean in normal => about ?% data (Empirical Rule)?</p>
          `,
          a: "68%",
          distract: ["50%","95%","99.7%"]
        })
      },
      // Q20
      {
        question: () => ({
          q: `
            <p><strong>Q20:</strong> The derivative of <code>x^3</code> is <code>3x^2</code>. True?</p>
          `,
          a: "True",
          distract: [
            "False, 2x",
            "No derivative in pre-calc",
            "No real solution"
          ]
        })
      },
      // Q21
      {
        question: () => ({
          q: `
            <p><strong>Q21:</strong> Let <code>f(x)=x^3</code>.
            Using the limit definition, the derivative at x = 1 is?</p>
          `,
          a: "3",
          distract: ["1", "0", "Undefined"]
        })
      },
      // Q22
      {
        question: () => ({
          q: `
            <p><strong>Q22:</strong> Evaluate the limit using L'Hôpital’s Rule:
            <code>lim_{x→0} \\dfrac{\\sin x}{x}</code>.</p>
          `,
          a: "1",
          distract: ["0", "∞", "Does not exist"]
        })
      },
      // Q23
      {
        question: () => ({
          q: `
            <p><strong>Q23:</strong> <code>(x^2 - 16)/(x-4)</code> => which factor is canceled?</p>
          `,
          a: "(x-4)",
          distract: ["(x+4)","No factor canceled","(x-4)(x+4) remain"]
        })
      },
      // Q24
      {
        question: () => ({
          q: `
            <p><strong>Q24:</strong> <code>log_2(32)</code>=?</p>
          `,
          a: "5",
          distract: ["4","6","No integer"]
        })
      },
      // Q25
      {
        question: () => ({
          q: `
            <p><strong>Q25:</strong> <code>sin(2x)=2 sin(x) cos(x)</code>. Double‐angle identity. True?</p>
          `,
          a: "True",
          distract: [
            "False",
            "Equivalent to sin^2(x)+cos^2(x)",
            "No known identity"
          ]
        })
      },
      // Q26
      {
        question: () => ({
          q: `
            <p><strong>Q26:</strong> A sinusoid <code>y=3 sin(4x)</code> => amplitude=? period=?</p>
          `,
          a: "Amplitude=3, period=π/2",
          distract: [
            "Amp=4, period=3π",
            "Amp=1, period=4π",
            "Amp=3, period=4π"
          ]
        })
      },
      // Q27
      {
        question: () => ({
          q: `
            <p><strong>Q27:</strong> The equation <code>\\ln x = x</code> has one
            real solution near x = 0.57.  Which method is typically used to find it?</p>
          `,
          a: "Numerical root-finding (e.g.&nbsp;Newton–Raphson)",
          distract: [
            "Exact algebraic rearrangement",
            "No real solution exists",
            "Graph has no intersection"
          ]
        })
      },
      // Q28
      {
        question: () => ({
          q: `
            <p><strong>Q28:</strong> After combining like terms, how many distinct
            terms are in the expansion of <code>(x + y)^3</code>?</p>
          `,
          a: "4",
          distract: ["3", "8", "6"]
        })
      },
      // Q29
      {
        question: () => ({
          q: `
            <p><strong>Q29:</strong> Probability of at least 1 head in 3 coin tosses?</p>
          `,
          a: "7/8",
          distract: ["1/8","3/8","1/2"]
        })
      },
      // Q30
      {
        question: () => ({
          q: `
            <p><strong>Q30:</strong> Standard normal distribution => μ=0, σ=1. True?</p>
          `,
          a: "True",
          distract: [
            "μ=1, σ=0",
            "No, that’s uniform distribution",
            "μ=0, σ=2"
          ]
        })
      },
      // Q31
      {
        question: () => ({
          q: `
            <p><strong>Q31:</strong> Evaluate <code>lim(x→∞) [ (2x^3)/(4x^3) ]</code> = ?</p>
          `,
          a: "1/2",
          distract: ["∞","0","Doesn’t exist"]
        })
      },
      // Q32
      {
        question: () => ({
          q: `
            <p><strong>Q32:</strong> <code>(f - g)(x)=f(x)-g(x)</code>. True or false?</p>
          `,
          a: "True",
          distract: ["False","It’s a product","No definition"]
        })
      },
      // Q33
      {
        question: () => ({
          q: `
            <p><strong>Q33:</strong> If <code>(x+2)</code> is a factor, then root is <code>x=?</code></p>
          `,
          a: "-2",
          distract: ["2","No real root from that factor","x=1/2"]
        })
      },
      // Q34
      {
        question: () => ({
          q: `
            <p><strong>Q34:</strong> For <code>y=1/(x-3)</code>, vertical asymptote at <code>x=?</code></p>
          `,
          a: "3",
          distract: ["-3","No asymptote","y=3"]
        })
      },
      // Q35
      {
        question: () => ({
          q: `
            <p><strong>Q35:</strong> If <code>10^x=100</code>, x=?</p>
          `,
          a: "2",
          distract: ["1","log(100)/10","No real solutions"]
        })
      },
      // Q36
      {
        question: () => ({
          q: `
            <p><strong>Q36:</strong> <code>cos(2θ)=1 - 2 sin^2(θ)</code>. True or false?</p>
          `,
          a: "True",
          distract: [
            "False",
            "No identity for cos(2θ)",
            "Equivalent to sin(2θ)"
          ]
        })
      },
      // Q37
      {
        question: () => ({
          q: `
            <p><strong>Q37:</strong> In <code>y=A sin(B(x-C))+D</code> => which is the vertical shift?</p>
          `,
          a: "D",
          distract: ["A","B","C"]
        })
      },
      // Q38
      {
        question: () => ({
          q: `
            <p><strong>Q38:</strong> In the expansion of
            <code>(a + b + c)^5</code>, the coefficient of
            <code>a<sup>2</sup>b<sup>2</sup>c</code> is?</p>
          `,
          a: "30",
          distract: ["10", "20", "40"]
        })
      },
      // Q39
      {
        question: () => ({
          q: `
            <p><strong>Q39:</strong> 7 distinct objects choose 7 => how many ways?</p>
          `,
          a: "1",
          distract: ["7C7=7","0","7P7=5040"]
        })
      },
      // Q40
      {
        question: () => ({
          q: `
            <p><strong>Q40:</strong> In a normal dist, ~99.7% data within 3σ. True?</p>
          `,
          a: "True",
          distract: [
            "False, 99% exactly",
            "No approximate rule",
            "50%"
          ]
        })
      },
      // Q41
      {
        question: () => ({
          q: `
            <p><strong>Q41:</strong> <code>lim (x→1) [ (x-1)(x+1 ) / (x-1) ]</code> => ?</p>
          `,
          a: "2",
          distract: ["0","∞","1"]
        })
      },
      // Q42
      {
        question: () => ({
          q: `
            <p><strong>Q42:</strong> The derivative of <code>5x^4</code> => ?</p>
          `,
          a: "20x^3",
          distract: ["5x^3","4x^5","No derivative in pre-calc"]
        })
      },
      // Q43
      {
        question: () => ({
          q: `
            <p><strong>Q43:</strong> <code>f(x)=|x|</code> is piecewise: x for x &ge; 0, -x for x &lt; 0. True?</p>
          `,
          a: "True",
          distract: [
            "False",
            "No piecewise form",
            "f(x)=x^2"
          ]
        })
      },
      // Q44
      {
        question: () => ({
          q: `
            <p><strong>Q44:</strong> <code>(x^2-25)/(x-5) = x+5</code> if <code>x≠5</code>. True?</p>
          `,
          a: "True",
          distract: [
            "False, it’s x-5",
            "No domain restrictions",
            "No factorization possible"
          ]
        })
      },
      // Q45
      {
        question: () => ({
          q: `
            <p><strong>Q45:</strong> <code>ln(e^3)=3</code>. True or false?</p>
          `,
          a: "True",
          distract: [
            "False, it’s 1/e^3",
            "No real meaning",
            "∞"
          ]
        })
      },
      // Q46
      {
        question: () => ({
          q: `
            <p><strong>Q46:</strong> <code>1 + cot^2(x)=csc^2(x)</code>. True or false?</p>
          `,
          a: "True",
          distract: [
            "False",
            "1+tan^2(x)=csc^2(x)",
            "cot^2(x)=1 - csc^2(x)"
          ]
        })
      },
      // Q47
      {
        question: () => ({
          q: `
            <p><strong>Q47:</strong> <code>y=3 sin(2x) + 4</code> => amplitude=?, vertical shift=?</p>
          `,
          a: "Amp=3, shift=4",
          distract: ["Amp=2, shift=3","Amp=4, shift=3","Amp=3, shift=2"]
        })
      },
      // Q48
      {
        question: () => ({
          q: `
            <p><strong>Q48:</strong> Solve <code>e^x=5</code> => <code>x=?</code></p>
          `,
          a: "<code>ln(5)</code>",
          distract: [
            "<code>log_5(e)</code>",
            "<code>5/e</code>",
            "No real solution"
          ]
        })
      },
      // Q49
      {
        question: () => ({
          q: `
            <p><strong>Q49:</strong> (# ways) to pick 2 from 4 ignoring order => <code>4C2=6</code>. True?</p>
          `,
          a: "True",
          distract: [
            "4",
            "8",
            "4P2=12"
          ]
        })
      },
      // Q50
      {
        question: () => ({
          q: `
            <p><strong>Q50:</strong> The derivative measures instantaneous rate of change. True or false?</p>
          `,
          a: "True",
          distract: [
            "False",
            "No concept of rate",
            "Only average rate"
          ]
        })
      }
    ];
  }
  